import React, { Component } from "react";
import Select from 'react-select';
import { ButtonToolbar, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faThLarge,
  faList,
  faThumbsUp,
  faStar,
  // faPlus
} from "@fortawesome/free-solid-svg-icons";
import { OrderType } from '../../constants/Types';
import { addEventNameToEndpoint } from '../../utils/common';
import "./ItemFilterBar.scss";

const orderOptions = [
  { value: OrderType.DATE_DESCENDING, label: 'Date added - newest first' },
  { value: OrderType.DATE_ASCENDING, label: 'Date added - oldest first' },
  { value: OrderType.DOCUMENT_TYPE, label: 'Content Type' },
  { value: OrderType.FILE_TYPE, label: 'File Type' },
  // { value: OrderType.FILE_NAME, label: 'Filename' },
];

const selectStyles = (width) => {
  return {
    control: styles => ({
      ...styles,
      backgroundColor: 'white',
      height: 32,
      width,
      minHeight: 20,
      marginRight: 10
    }),
  }
};

class ItemFilterBar extends Component {
  constructor(props) {
    super (props);

    this.state = {
    }
  }

  handleGridChange = (value) => {
    this.onPassChange({ gridStyle: value });

    if (value === 0) {
      addEventNameToEndpoint(this.props.Analytics, 'user-mainViewGrid-select');
      this.props.Analytics.record({name: 'user-mainViewGrid-select', metrics: { countItems: this.props.itemCount }});
    } else {
      addEventNameToEndpoint(this.props.Analytics, 'user-mainViewList-select');
      this.props.Analytics.record({name: 'user-mainViewList-select', metrics: { countItems: this.props.itemCount }});
    }
  }

  onFunnelStageChange = (value) => {
    this.onPassChange({ funnelStage: value ? value.value : null });
    if (value) {
      addEventNameToEndpoint(this.props.Analytics, 'user-filterFunnelStage-select');
      this.props.Analytics.record({name: 'user-filterFunnelStage-select', attributes: { funnelStageName: value.value }, metrics: { countItems: this.props.itemCount }});
    }
  }

  onFeatureFilter = (type) => {
    switch (type) {
      case 'voted':
        this.onPassChange({
          isVoted: !this.props.filters.isVoted,
          isFavorite: false,
          isPopular: false
        });

        if (!this.props.filters.isVoted) {
          addEventNameToEndpoint(this.props.Analytics, 'user-filterVoted-select');
          this.props.Analytics.record({name: 'user-filterVoted-select', metrics: { countItems: this.props.itemCount }});
        }
        break;
      case 'favorite':
        this.onPassChange({
          isVoted: false,
          isFavorite: !this.props.filters.isFavorite,
          isPopular: false
        });

        if (!this.props.filters.isFavorite) {
          addEventNameToEndpoint(this.props.Analytics, 'user-filterFavorites-select');
          this.props.Analytics.record({name: 'user-filterFavorites-select', metrics: { countItems: this.props.itemCount }});
        }
        break;
      case 'popular':
        this.onPassChange({
          isFavorite: false,
          isVoted: false,
          isPopular: !this.props.filters.isPopular
        });

        if (!this.props.filters.isPopular) {
          addEventNameToEndpoint(this.props.Analytics, 'user-filterPopular-select');
          this.props.Analytics.record({name: 'user-filterPopular-select', metrics: { countItems: this.props.itemCount }});
        }
        break;
      default:
        break;
    }
  }

  onPassChange = (filters) => {
    if (this.props.onChange) {
      this.props.onChange(filters);
    }
  }

  onChangeOrderType = (value) => {
    this.onPassChange({ orderType: value ? value.value : null });
    if (value) {
      addEventNameToEndpoint(this.props.Analytics, 'user-filterOrderType-select');
      this.props.Analytics.record({ name: 'user-filterOrderType-select', attributes: { orderType: value.value } });
    }
  }

  render() {
    // const { funnelStages } = this.props.settings;
    const {
      isVoted,
      isFavorite,
      gridStyle,
      // funnelStage,
      orderType
    } = this.props.filters;
    
    // const funnelOptions = Object.keys(funnelStages || {}).map(key => ({
    //   value: key,
    //   label: key
    // }));

    return (
      <div className="item-filter-bar">
        <div className="right-filter-actions">
          <div
            className={`filter-type${isVoted ? ' selected' : ''}`}
            onClick={() => this.onFeatureFilter('voted')}
          >
            <FontAwesomeIcon icon={faThumbsUp} />
            <span>Voted</span>
          </div>
          <div
            className={`filter-type${isFavorite ? ' selected' : ''}`}
            onClick={() => this.onFeatureFilter('favorite')}
          >
            <FontAwesomeIcon icon={faStar} />
            <span>Favorites</span>
          </div>
          {/* TODO add in popularity */}
          {/* <div
            className={`filter-type${isPopular ? ' selected' : ''}`}
            onClick={() => this.onFeatureFilter('popular')}
          >
            <FontAwesomeIcon icon={faFireAlt} />
            <span>Popular</span>
          </div> */}
          <Select
            options={orderOptions}
            styles={selectStyles(250)}
            placeholder="Order By"
            onChange={this.onChangeOrderType}
            value={orderType ? { value: OrderType[orderType], label: orderOptions.find(or => or.value === orderType).label } : null}
            isClearable={true}
          />
        </div>
        <ButtonToolbar>
          <ToggleButtonGroup type="radio" name="options" defaultValue={gridStyle} onChange={this.handleGridChange}>
            <ToggleButton value={0} size="sm"><FontAwesomeIcon icon={faThLarge} /></ToggleButton>
            <ToggleButton value={1} size="sm"><FontAwesomeIcon icon={faList} /></ToggleButton>
          </ToggleButtonGroup>
        </ButtonToolbar>
      </div>
    );
  }  
}

export default ItemFilterBar;
